// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Krzc","header":"PatientQuestionnaire_header__2miZQ","info":"PatientQuestionnaire_info__1j_9u"};